(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    if (!window.__ottoPriceFilterActionsBound) {
    window.__ottoPriceFilterActionsBound = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[data-element="apply-price"], button[data-element="clear-price"]');
      if (!button || button.closest('#collection-filter-sheet')) return;
      const filter = button.closest('[data-module="price-filter"]');
      const minInput = filter?.querySelector('[data-element="price-min"]');
      const maxInput = filter?.querySelector('[data-element="price-max"]');
      if (!minInput || !maxInput) return;

      event.preventDefault();
      event.stopPropagation();
      if (button.dataset.element === 'clear-price') {
        minInput.value = '';
        maxInput.value = '';
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('page');
      if (minInput.value.trim()) url.searchParams.set('filter.v.price.gte', minInput.value.trim());
      if (maxInput.value.trim()) url.searchParams.set('filter.v.price.lte', maxInput.value.trim());
      window.location.assign(url.toString());
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-print"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ottoProductPrint) return;
    window.__ottoProductPrint = true;
    document.documentElement.classList.add('product-print-ready');

    function cleanClone(source, doc) {
      const clone = doc.importNode(source, true);
      clone.querySelectorAll('script, style, template, iframe, form, button, input, select, textarea, dialog, .product-wine-profile__reviews-carousel, .product-description__teaser, [aria-hidden="true"]').forEach(el => el.remove());
      [clone, ...clone.querySelectorAll('*')].forEach(el => {
        [...el.attributes].forEach(attr => {
          if (/^on/i.test(attr.name) || attr.name === 'id' || attr.name.startsWith('data-')) el.removeAttribute(attr.name);
          if (['href', 'src', 'xlink:href'].includes(attr.name) && /^\s*javascript:/i.test(attr.value)) el.removeAttribute(attr.name);
        });
        if (el.tagName === 'DETAILS') el.open = true;
        if (el.tagName === 'IMG') {
          el.src = new URL(el.getAttribute('src'), location.href).href;
          el.removeAttribute('srcset');
          el.loading = 'eager';
        }
      });
      return clone;
    }

    document.addEventListener('click', async event => {
      const trigger = event.target.closest('[data-product-print]');
      if (!trigger || !matchMedia('(min-width: 1024px)').matches) return;
      const template = document.getElementById('ProductPrint-' + trigger.dataset.productPrint);
      const productRoot = trigger.closest('product-information');
      if (!template || !productRoot) return;
      event.preventDefault();
      const printWindow = window.open('', '_blank');
      if (!printWindow) { window.alert(template.dataset.blocked); return; }
      const doc = printWindow.document;
      try {
        doc.open();
        doc.write('<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body></body></html>');
        doc.close();
        doc.documentElement.lang = template.dataset.locale;
        doc.title = template.dataset.title + ' - Otto Suenson';
        const base = doc.createElement('base');
        base.href = location.href;
        doc.head.append(base);
        const content = doc.importNode(template.content, true);
        const titlePlaceholder = content.querySelector('[data-print-title]');
        const printHeading = doc.createElement('h1');
        printHeading.textContent = titlePlaceholder.textContent;
        titlePlaceholder.replaceWith(printHeading);
        doc.head.append(content.querySelector('style'));
        doc.body.append(content);
        doc.querySelectorAll('script, iframe').forEach(el => el.remove());
        doc.querySelectorAll('*').forEach(el => [...el.attributes].filter(a => /^on/i.test(a.name)).forEach(a => el.removeAttribute(a.name)));
        const put = (selector, source) => {
          if (!source) return;
          const target = doc.querySelector(selector);
          target.append(cleanClone(source, doc));
          target.hidden = false;
        };
        put('[data-print-price]', productRoot.querySelector('[data-product-price] price'));
        put('[data-print-certifications]', productRoot.querySelector('.product-info-cert-badges'));
        put('[data-print-facts]', productRoot.querySelector('.product-details'));
        put('[data-print-profile]', productRoot.querySelector('.product-wine-profile-universe'));
        const selectedId = productRoot.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        const variants = JSON.parse(document.getElementById('ProductPrintVariants-' + trigger.dataset.productPrint)?.textContent || '[]');
        const variant = variants.find(v => String(v.id) === selectedId);
        if (variant?.sku) {
          doc.querySelector('[data-print-sku] span').textContent = variant.sku;
          doc.querySelector('[data-print-sku]').hidden = false;
        }
        if (variant?.title && variant.title !== 'Default Title') {
          doc.querySelector('[data-print-variant]').textContent = variant.title;
          doc.querySelector('[data-print-variant]').hidden = false;
        }
        const image = productRoot.querySelector('[data-current-media] img');
        if (image && doc.querySelector('.print-image')) {
          doc.querySelector('.print-image').src = image.currentSrc || image.src;
          doc.querySelector('.print-image').removeAttribute('srcset');
        }
        const seen = new Set([location.pathname]);
        const related = doc.querySelector('.print-related-grid');
        const candidates = [...document.querySelectorAll('#main-content .section--collection-with-products product-card, #main-content product-recommendations product-card, #main-content [data-rec-module] product-card')].filter(card => {
          const link = card.querySelector('a[href*="/products/"]');
          return card.getClientRects().length && !card.closest('dialog, cart-drawer, product-information') && link && card.querySelector('.product-card__title') && new URL(link.href).pathname !== location.pathname;
        });
        const sameProducer = template.dataset.vendor ? candidates.filter(card => card.dataset.productVendor === template.dataset.vendor) : [];
        const cards = sameProducer.length ? sameProducer : candidates;
        if (sameProducer.length) doc.querySelector('[data-print-related] h2').textContent = template.dataset.moreFrom + ' ' + template.dataset.vendor;
        for (const card of cards) {
          if (related.children.length === 3) break;
          if (!card.getClientRects().length || card.closest('dialog, cart-drawer, product-information')) continue;
          const link = card.querySelector('a[href*="/products/"]');
          const title = card.querySelector('.product-card__title');
          if (!link || !title) continue;
          const url = new URL(link.href);
          if (seen.has(url.pathname)) continue;
          seen.add(url.pathname);
          const item = doc.createElement('article');
          item.className = 'print-related-card';
          const img = card.querySelector('product-card-image img');
          if (img) item.append(cleanClone(img, doc));
          const heading = doc.createElement('h3');
          const anchor = doc.createElement('a');
          anchor.href = url.origin + url.pathname;
          anchor.textContent = title.textContent.trim();
          heading.append(anchor);
          item.append(heading);
          const meta = card.querySelector('.product-card__meta');
          if (meta) item.append(cleanClone(meta, doc));
          const price = card.querySelector('price');
          if (price) item.append(cleanClone(price, doc));
          related.append(item);
        }
        doc.querySelector('[data-print-related]').hidden = !related.children.length;
        doc.querySelector('[data-print-date]').textContent = new Intl.DateTimeFormat(template.dataset.locale, {dateStyle: 'long'}).format(new Date());
        const ready = Promise.all([
          doc.fonts.load('400 10pt OttoPrintBody').catch(() => {}),
          doc.fonts.load('700 10pt OttoPrintBody').catch(() => {}),
          doc.fonts.load('400 27pt OttoPrintDisplay').catch(() => {}),
          ...[...doc.images].map(img => img.decode().catch(() => {}))
        ]);
        await Promise.race([ready, new Promise(resolve => setTimeout(resolve, 6000))]);
        const confirm = doc.querySelector('[data-print-confirm]');
        confirm.disabled = false;
        confirm.addEventListener('click', () => { printWindow.focus(); printWindow.print(); });
        printWindow.opener = null;
      } catch (error) {
        printWindow.close();
        window.alert(template.dataset.blocked);
        console.error('Product print could not be prepared', error);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
